import React, { createContext, useReducer } from 'react'

export const SHOW_DEPENDENCY_MODAL = 'show_dependency_modal'

const Reducer = (data, payload) => {
  switch (payload.type) {
    case SHOW_DEPENDENCY_MODAL: {
      return { ...data, show_dependency_modal: payload.data }
    }
    default: {
      return {}
    }
  }
}

const initialState = {
  show_dependency_modal: false,
}

const DtcDependencyStore = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState)

  return (
    <DtcDependencyContext.Provider value={[state, dispatch]}>
      {children}
    </DtcDependencyContext.Provider>
  )
}

export const DtcDependencyContext = createContext(initialState)
export default DtcDependencyStore
